import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import Helper from "composer/Helper.jsx"

import DeploymentTable from "composer/views/deployment/DeploymentTable.jsx"
import PushDownloadDialog from "composer/views/deployment/PushDownloadDialog.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Icon,
} from '@material-ui/core';

class DeploymentViewerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},

      sortBy: "time_from",
      sortInAsc: false,

      data: [],
      open: false,
    };
    autoBind(this);
  }

  handleEnter() {
    this.getServerDownloadQueue(0);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();
  }

  getServerDownloadQueue(pageNumber) {
    let requestObj = {
      school_id: this.props.root.getMySchoolId(),
      item_per_page: 10,
      page_number: 0,
    };
    this.props.root.refs.API.request("get_push_download_items", requestObj, this.getServerDownloadQueueOK, this.getServerDownloadQueueFailed);
  }

  getServerDownloadQueueOK(res) {
    let result = res.body['result'];
    this.setState({ data: result });
    this.state.data = result;

    this.sortData();
  }

  getServerDownloadQueueFailed(err) {
    console.log("get server download queue failed");
  }

  sortAlphabetDataBy(option) {
    this.setState({ sortBy: option });

    let asc = this.state.sortInAsc;
    let sortedData = this.state.data.sort(function(a, b) {
      if (a[option].toLowerCase() < b[option].toLowerCase()) {
        return (asc ? -1 : 1);
      }
      else if (a[option].toLowerCase() > b[option].toLowerCase()) {
        return (asc ? 1 : -1);
      }
      else {
        if (a['locale_name'] < b['locale_name']) {
          return (asc ? -1 : 1);
        }
        else {
          return (asc ? 1 : -1);
        }
      }
    });

    this.setState({ data: sortedData });
  }

  sortDateTimeBy(option) {
    this.setState({ sortBy: option });

    let asc = this.state.sortInAsc;
    let sortedData = this.state.data.sort(function(a, b) {
      let dateString0 = Helper.timestampToDateString(a[option]);
      let dateString1 = Helper.timestampToDateString(b[option]);
      let difference = new Date(dateString0) - new Date(dateString1);
      if (difference < 0) {
        return (asc ? -1 : 1);
      }
      else if (difference > 0) {
        return (asc ? 1 : -1);
      }
      else {
        if (a['locale_name'] < b['locale_name']) {
          return (asc ? -1 : 1);
        }
        else {
          return (asc ? 1 : -1);
        }
      }
    });

    this.setState({ data: sortedData });
  }

  switchSortOrder() {
    let order = !this.state.sortInAsc;
    this.setState({ sortInAsc: order });
    this.state.sortInAsc = order;
  }

  sortData() {
    if (this.state.sortBy == "locale_name") {
      this.sortAlphabetDataBy(this.state.sortBy);
    }
    else if (this.state.sortBy == "time_from" || this.state.sortBy == "time_to" || this.state.sortBy == "time_update") {
      this.sortDateTimeBy(this.state.sortBy);
    }
  }

  addPushDownloadItemClicked() {
    this.refs.pushDownloadDialog.setState({ open: true });
  }

  reload() {
    this.refs.deploymentTable.deselectAll();
    this.getServerDownloadQueue(0);
  }

  refreshPushDownloadItemClicked() {
    this.reload();
  }

  render() {
    return (
      <div>
        <PushDownloadDialog parent={this} root={this.props.root} ref="pushDownloadDialog"/>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'xl'}
          onEnter={this.handleEnter}
          onClose={this.handleClose}
        >
          <DialogTitle>{Localization.strings.DEPLOYMENT}</DialogTitle>
          <DialogContent>
            <Button onClick={this.addPushDownloadItemClicked}>
              <Icon className="buttonIconLeft">add</Icon>
              {Localization.strings.ADD}
            </Button>
            <Button onClick={this.refreshPushDownloadItemClicked}>
              <Icon className="buttonIconLeft">refresh</Icon>
              {Localization.strings.REFRESH}
            </Button>
            <DeploymentTable parent={this} root={this.props.root} ref="deploymentTable"
              data={this.state.data}
              sortBy={this.state.sortBy}
              sortInAsc={this.state.sortInAsc}
            />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CLOSE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default DeploymentViewerDialog;
